import _ from 'lodash';
import { redirectToLogin } from '../helpers';
import constants from './constants';

const initialState = {
  error: false,
  reason: '',
  message: '',
  title: '',
};

const unauthCodes = [401, 403];

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.actions.ERROR: {
      if (unauthCodes.includes(_.get(action.reason, 'status'))) {
        redirectToLogin();
      }
      return {
        ...state,
        error: true,
        reason: action.reason,
        message: action.message,
        title: action.title,
      };
    }
    default:
      return state;
  }
}
